import { ADD_CREDENTIALS, SET_AUTH_STATUS, DO_LOGOUT } from '../actions/constants'

const rootReducer = (state, action) => {
	switch(action.type) {
		case ADD_CREDENTIALS:
			return { ...state, credentials: action.payload };
		case SET_AUTH_STATUS:
			return { ...state, authStatus: action.payload };
		case DO_LOGOUT:
			return { ...state, authStatus: 'ANONYMOUS', credentials: {token: "", username: ""}}
		default:
			return state;
	}
};

export default rootReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/index.js